import React, { useEffect, useRef, useState } from 'react'
import { Dialog, Slide } from '@material-ui/core'
import VideoSubtitleEditor from './VideoSubtitleEditor'

function SubtitleEditor({ handleClose, open, ...props }) {

  const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />
  })

  return (
    <Dialog
      fullScreen
      onClose={handleClose}
      open={open}
    //   TransitionComponent={Transition}
    >
      <VideoSubtitleEditor {...props}/>
    </Dialog>
  )
}

export default SubtitleEditor
